var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 3.83301L8.4706 8.59588C9.02158 8.98156 9.29707 9.1744 9.59672 9.2491C9.86142 9.31508 10.1383 9.31508 10.403 9.2491C10.7026 9.1744 10.9781 8.98156 11.5291 8.59588L18.3332 3.83301M5.6665 14.6663H14.3332C15.7333 14.6663 16.4334 14.6663 16.9681 14.3939C17.4386 14.1542 17.821 13.7717 18.0607 13.3013C18.3332 12.7665 18.3332 12.0665 18.3332 10.6663V5.33301C18.3332 3.93288 18.3332 3.23281 18.0607 2.69803C17.821 2.22763 17.4386 1.84517 16.9681 1.60549C16.4334 1.33301 15.7333 1.33301 14.3332 1.33301H5.6665C4.26637 1.33301 3.56631 1.33301 3.03153 1.60549C2.56112 1.84517 2.17867 2.22763 1.93899 2.69803C1.6665 3.23281 1.6665 3.93288 1.6665 5.33301V10.6663C1.6665 12.0665 1.6665 12.7665 1.93899 13.3013C2.17867 13.7717 2.56112 14.1542 3.03153 14.3939C3.56631 14.6663 4.26637 14.6663 5.6665 14.6663Z",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.11fa06c9c66643f4d3c891fa2872c847.svg";
export { ForwardRef as ReactComponent };